import { jwtDecode } from 'jwt-decode';

interface DecodedToken {
  id: string;
  name: string;
  email: string;
  role: 'user' | 'admin';
  exp: number;
}

export const isAuthenticated = (): boolean => {
  const token = localStorage.getItem('token');
  console.log('Token from localStorage:', token);
  
  if (!token) {
    console.log('No token found');
    return false;
  }

  try {
    const decoded = jwtDecode<DecodedToken>(token);
    console.log('Decoded token:', decoded);
    
    const expirationTime = decoded.exp * 1000;
    const currentTime = Date.now();
    console.log('Expiration time:', new Date(expirationTime));
    console.log('Current time:', new Date(currentTime));
    console.log('Is token expired?', expirationTime <= currentTime);
    
    return expirationTime > currentTime;
  } catch (error) {
    console.error('Error decoding token:', error);
    return false;
  }
};

export const isAdmin = (): boolean => {
  const token = localStorage.getItem('token');
  console.log('Token from localStorage (admin check):', token);
  
  if (!token) {
    console.log('No token found for admin check');
    return false;
  }

  try {
    const decoded = jwtDecode<DecodedToken>(token);
    console.log('Decoded token (admin check):', decoded);
    
    const expirationTime = decoded.exp * 1000;
    const currentTime = Date.now();
    console.log('Expiration time (admin check):', new Date(expirationTime));
    console.log('Current time (admin check):', new Date(currentTime));
    console.log('Is token expired? (admin check):', expirationTime <= currentTime);
    console.log('Is user admin?', decoded.role === 'admin');
    
    return decoded.role === 'admin' && expirationTime > currentTime;
  } catch (error) {
    console.error('Error decoding token (admin check):', error);
    return false;
  }
};

export const getCurrentUser = (): DecodedToken | null => {
  const token = localStorage.getItem('token');
  if (!token) return null;

  try {
    const decoded = jwtDecode<DecodedToken>(token);
    if (decoded.exp * 1000 > Date.now()) {
      return decoded;
    }
    return null;
  } catch (error) {
    return null;
  }
}; 